import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import Typography from '../typography/Typography';
import { ActivePage, PageButton } from './styles';
export const SinglePage = ({ currentPage, index, onClick, }) => {
    const { colors } = useTheme();
    return currentPage === index ? (_jsx(ActivePage, { children: _jsx(Typography, { type: "caption", fontFamily: "primaryBold", color: colors.interactive.brandColor, children: currentPage }) })) : (_jsx(PageButton, { onClick: () => onClick(index), children: _jsx(Typography, { color: colors.text.secondary, type: "bodyButton", fontFamily: "primaryMedium", children: index }) }));
};
//# sourceMappingURL=SinglePage.js.map